{
  "#MAINFLAVOURENERGY": {
    "type": "vimeo",
    "id": "1194609088"
  },
  "#UNCENSORYOURHEALTH": {
    "type": "youtube",
    "id": "8rr_up6f5EE"
  },
  "(SAVE A) LIFE INSURANCE": {
    "type": "youtube",
    "id": "agwwvJrXLhs"
  },
  "30UNDER30": {
    "type": "youtube",
    "id": "ZcIX4jEKUo0"
  },
  "600K NETWORK": {
    "type": "youtube",
    "id": "k2U1G8xCYus"
  },
  "867-5309": {
    "type": "youtube",
    "id": "jzFpWNbQfp8"
  },
  "A CRITTER CAROL": {
    "type": "vimeo",
    "id": "1140829189"
  },
  "A CRY FOR HYDRATION": {
    "type": "youtube",
    "id": "a8Fd8MLCmvQ"
  },
  "A DRUGSTORE IN YOUR PESEBRE": {
    "type": "youtube",
    "id": "PlezpHe6_lM"
  },
  "A MOTHER\u2019S COMMENTARY": {
    "type": "youtube",
    "id": "a4ZCQDgxW0U"
  },
  "A TIME AND A PLACE": {
    "type": "youtube",
    "id": "X4i0k68wOGU"
  },
  "A.I. IRRESPONSIBLY": {
    "type": "youtube",
    "id": "LE2tp1wTjhg"
  },
  "ADS IN MY PHONE CALL": {
    "type": "vimeo",
    "id": "1189899289"
  },
  "AFTER SHIT HAPPENED SERVICE": {
    "type": "vimeo",
    "id": "1177559337"
  },
  "AN AGENT \u201cCOMO A GENTE\u201d": {
    "type": "vimeo",
    "id": "1186040589"
  },
  "APPLE TV REBRAND": {
    "type": "youtube",
    "id": "MWfJcl8deLE"
  },
  "AXA X SONITA: THE LONE VOICE": {
    "type": "youtube",
    "id": "5g3bydOAu3k"
  },
  "BACK TO KAI TAK": {
    "type": "youtube",
    "id": "Dpb4yzz85CQ"
  },
  "BAD BUNNY HALFTIME SHOW": {
    "type": "youtube",
    "id": "G6FuWd4wNd8"
  },
  "BEAT CANCER OFF": {
    "type": "vimeo",
    "id": "1203383874"
  },
  "BEAT CANCER OFF FILM": {
    "type": "vimeo",
    "id": "1179609250"
  },
  "BEDTIME DONATIONS": {
    "type": "youtube",
    "id": "nw12Kyu0wqQ"
  },
  "BORN IN ROMA RENDEZVOUS IVORY COLLECTION / STUDIO 54 EXPERIENCE": {
    "type": "youtube",
    "id": "eWUEiYyA7Ug"
  },
  "BRING A BOOK TO LIFE": {
    "type": "vimeo",
    "id": "1103797486"
  },
  "BUILD YOUR OWN SUPER BOWL COMMERCIAL": {
    "type": "vimeo",
    "id": "1204133679"
  },
  "CAMERA ROLLS: GIG, WEDDING, BOWLING": {
    "type": "youtube",
    "id": "Xzm_7YZ1sy8"
  },
  "CAN I GET A SIX PACK QUICKLY?": {
    "type": "youtube",
    "id": "NuEXYfbV_PA"
  },
  "CANCER PREVENTION DISCOUNTS": {
    "type": "youtube",
    "id": "OCWwHVcGozA"
  },
  "CHANGE MY MIND": {
    "type": "youtube",
    "id": "a4ouJAuo1ag"
  },
  "CHEETOS FLAMIN\u2019 HOT DILL PICKLE MEMORABILIA": {
    "type": "vimeo",
    "id": "1204193109"
  },
  "CHEETOS THING-ERTIPS": {
    "type": "youtube",
    "id": "AQREpnGLU_8"
  },
  "CHICKEN SCREAMS FOR COKE": {
    "type": "youtube",
    "id": "CT_K3_h2zu4"
  },
  "CHUPA CHUPS IMPOSSIBLE": {
    "type": "vimeo",
    "id": "1185473956"
  },
  "CLEAN MY NAME": {
    "type": "vimeo",
    "id": "1187492812"
  },
  "CODE FOR THE PROTECTION AND INCLUSION OF BLACK CONSUMERS": {
    "type": "youtube",
    "id": "IxltEOZhPpU"
  },
  "CODE HER": {
    "type": "vimeo",
    "id": "1202270006"
  },
  "CONDENSED IDENTITY": {
    "type": "vimeo",
    "id": "1203791570"
  },
  "COPYCATS WELCOME": {
    "type": "youtube",
    "id": "izSoHjBvAwA"
  },
  "COQU\u00cd ALARMED": {
    "type": "youtube",
    "id": "55knFa5zP6g"
  },
  "COULD HAVE BEEN A HEINEKEN": {
    "type": "vimeo",
    "id": "1203492482"
  },
  "COVER IT": {
    "type": "vimeo",
    "id": "1195440551"
  },
  "CRACKED ROYALE": {
    "type": "vimeo",
    "id": "1187383775"
  },
  "CRAFTMAN.SHIPS": {
    "type": "vimeo",
    "id": "1203783886"
  },
  "CROSSES FOR CRISIS": {
    "type": "vimeo",
    "id": "1200962755"
  },
  "CUSTOM BILLBOARDS": {
    "type": "vimeo",
    "id": "1190157662"
  },
  "DANCEBOOK BRASIL": {
    "type": "youtube",
    "id": "NxkU4hE_GLw"
  },
  "DARK MODE ADS": {
    "type": "vimeo",
    "id": "1188653060"
  },
  "DEAR DIFFERENCE": {
    "type": "vimeo",
    "id": "1203783616"
  },
  "DEFINING HELP": {
    "type": "youtube",
    "id": "cj1cc2JMQbA"
  },
  "DELIVERED BY TETRIS": {
    "type": "youtube",
    "id": "JPSOD_c4AoY"
  },
  "DIRTY BUSINESS": {
    "type": "youtube",
    "id": "Prs4OLPIl8A"
  },
  "DISCOUNT CHANTS": {
    "type": "youtube",
    "id": "k2JGGB1tPEA"
  },
  "DONATE TO PLAY": {
    "type": "vimeo",
    "id": "1200485742"
  },
  "DON\u2019T LOOK UP": {
    "type": "vimeo",
    "id": "1203797654"
  },
  "DOORBELL ADS": {
    "type": "vimeo",
    "id": "1187878678"
  },
  "DOVE R/EAL REVIEWS": {
    "type": "vimeo",
    "id": "1204109832"
  },
  "DRESS YOURSELF": {
    "type": "vimeo",
    "id": "1119787096"
  },
  "DROP IN": {
    "type": "vimeo",
    "id": "1119239917"
  },
  "DYING REVIEWS": {
    "type": "vimeo",
    "id": "1202153419"
  },
  "ESCAPE VEHICLE": {
    "type": "youtube",
    "id": "pzG0C7oIfRE"
  },
  "EVERYONE WANTS A PIECE": {
    "type": "vimeo",
    "id": "1195332948"
  },
  "EXPEDITION IMPOSSIBLE": {
    "type": "youtube",
    "id": "N0WxAUkBuQA"
  },
  "EXPENSIVE SH*T": {
    "type": "youtube",
    "id": "Xhx4Xb6ytVo"
  },
  "EXPLORE YOUR STORY": {
    "type": "youtube",
    "id": "nxsN46De98A"
  },
  "FAIR PLAY": {
    "type": "youtube",
    "id": "ukSi-EQd5Ao"
  },
  "FANTASTIC KEYS": {
    "type": "youtube",
    "id": "e4SIlC4Ey_Y"
  },
  "FANTASY HERD": {
    "type": "youtube",
    "id": "6rALJlRjRV8"
  },
  "FATAL QUESTION": {
    "type": "vimeo",
    "id": "1116140170"
  },
  "FERTILIZER 2.5": {
    "type": "youtube",
    "id": "FgaPnTcDJf8"
  },
  "FIELD BARCODE": {
    "type": "vimeo",
    "id": "1186329990"
  },
  "FIRST SCHOOL POO": {
    "type": "vimeo",
    "id": "1084183002"
  },
  "FOR PAPA!": {
    "type": "youtube",
    "id": "a1ysUdRLjaE"
  },
  "FORESTS WITHOUT NAMES": {
    "type": "vimeo",
    "id": "1186399882"
  },
  "FRAGMENTAL MEDAL": {
    "type": "youtube",
    "id": "sAJ2MBpqQWc"
  },
  "GAME ON BALL": {
    "type": "vimeo",
    "id": "1200437924"
  },
  "GEORGIA, MISSOURI, PENNSYLVANIA": {
    "type": "youtube",
    "id": "O5fq09z_CqU"
  },
  "GLOWING RELIEF": {
    "type": "vimeo",
    "id": "1103711778"
  },
  "GOOD DAYS": {
    "type": "vimeo",
    "id": "1150526756"
  },
  "GOODBYE RX-7: SAYING FAREWELL TO A DEAR FRIEND": {
    "type": "youtube",
    "id": "nf3_lwSIShg"
  },
  "HARD TO MAKE EASY TO DRINK": {
    "type": "youtube",
    "id": "12e7K4K3IpA"
  },
  "HEALING ERA, THE HUSTLE, DELULU IS THE SOLULU": {
    "type": "youtube",
    "id": "cjAwhbK_ZBQ"
  },
  "HEAR IN HIJAB": {
    "type": "youtube",
    "id": "7dWApCCI_Uo"
  },
  "HEINZ DIPPER": {
    "type": "vimeo",
    "id": "1187334779"
  },
  "HELP!": {
    "type": "vimeo",
    "id": "1204811319"
  },
  "HERE TO STAY": {
    "type": "youtube",
    "id": "l8qHNQp0rgk"
  },
  "HIDDEN TAGS": {
    "type": "vimeo",
    "id": "1087698212"
  },
  "HOPE, MORNINGS, PICKY, AWAKE": {
    "type": "vimeo",
    "id": "1096194558"
  },
  "HOW CAN I COMMUNICATE BETTER WITH MY MOM?": {
    "type": "youtube",
    "id": "8ZnGqg87FEo"
  },
  "I THINK OF YOU DYING": {
    "type": "vimeo",
    "id": "1080372107"
  },
  "IKEA PREOWNED/SECOND-HAND MARKETPLACE": {
    "type": "youtube",
    "id": "cIr4nVS258M"
  },
  "IN GOOD TIME": {
    "type": "vimeo",
    "id": "1127387388"
  },
  "INDIANIS DENTRIS": {
    "type": "vimeo",
    "id": "1197548000"
  },
  "INFINITE SAREE": {
    "type": "youtube",
    "id": "jtUJEyTXqXU"
  },
  "IT STARTS OUTSIDE": {
    "type": "youtube",
    "id": "9fkJ8uvZsmM"
  },
  "IT\u2019S TIME TO STOP!": {
    "type": "youtube",
    "id": "nqVYSGWrKso"
  },
  "I\u2019M NOT REMARKABLE": {
    "type": "vimeo",
    "id": "1145798005"
  },
  "KEEP THINKING": {
    "type": "vimeo",
    "id": "1124860904"
  },
  "KITKAT SECURITY DETAIL": {
    "type": "youtube",
    "id": "VfDoqCGYrms"
  },
  "KYLE F*CKING CONNOR": {
    "type": "youtube",
    "id": "bSL1iz37-Gg"
  },
  "LANGUAGE OF BEDWETTING": {
    "type": "vimeo",
    "id": "1188452653"
  },
  "LET IT FLY": {
    "type": "vimeo",
    "id": "1163152448"
  },
  "LET\u2019S END FAST TECH": {
    "type": "vimeo",
    "id": "1203484921"
  },
  "LIGHT HOLE": {
    "type": "vimeo",
    "id": "1203797667"
  },
  "LIME GUIDES": {
    "type": "vimeo",
    "id": "1188248881"
  },
  "LISTENING, STRUMMING, READING, DAYDREAMING": {
    "type": "youtube",
    "id": "Dr7pQhIHtjw"
  },
  "LONG LASTING PASSPORT": {
    "type": "vimeo",
    "id": "1093368537"
  },
  "LOOK FAMILIAR?": {
    "type": "youtube",
    "id": "7vuZx0ue7z0"
  },
  "LOOK FOR THE LEAF": {
    "type": "youtube",
    "id": "xDat0VSgKKk"
  },
  "LOVE HURTS": {
    "type": "youtube",
    "id": "Kxin3pcPtGs"
  },
  "LUCKY FAN INDEX": {
    "type": "vimeo",
    "id": "1182366532"
  },
  "L\u2019ULTIMO UOMO REALE \u201cTHE LAST REAL MAN\u201d": {
    "type": "vimeo",
    "id": "1182407532"
  },
  "M&M\u2019S RICKTOK": {
    "type": "vimeo",
    "id": "1189884974"
  },
  "MADE TO SHARE": {
    "type": "vimeo",
    "id": "1078890101"
  },
  "MAGNIF-EYE": {
    "type": "youtube",
    "id": "eBGXpPUGfZo"
  },
  "MANDATORY VACATION PACKAGES": {
    "type": "vimeo",
    "id": "1193665346"
  },
  "MARSEILLE C\u2019EST NOUS.": {
    "type": "youtube",
    "id": "8aVYID0-at8"
  },
  "MCDELIVERY SPEED CAMERA ADS": {
    "type": "youtube",
    "id": "2Bjipa4Wnk8"
  },
  "MISSING LETTERS OF WORTH": {
    "type": "vimeo",
    "id": "1185826420"
  },
  "MNTANA KA GOGO": {
    "type": "youtube",
    "id": "q1QNAOA2Q64"
  },
  "MOTHER STRIKE": {
    "type": "youtube",
    "id": "MU6XGbpTAQY"
  },
  "MOVING LANDSCAPES": {
    "type": "vimeo",
    "id": "1203799985"
  },
  "MY JAPAN RAILWAY": {
    "type": "youtube",
    "id": "FOctNTQH1dM"
  },
  "NEVER OVER": {
    "type": "youtube",
    "id": "CtxdhnieTCQ"
  },
  "NIGRUM CORPUS": {
    "type": "vimeo",
    "id": "1089083708"
  },
  "NO BLUE, NO GREEN": {
    "type": "vimeo",
    "id": "1201108240"
  },
  "NO FRAME MISSED": {
    "type": "vimeo",
    "id": "1112735008"
  },
  "NO PROJECT WITHOUT DRAMA": {
    "type": "vimeo",
    "id": "1113169877"
  },
  "NOTHING STOPS WOMEN\u2019S RUGBY": {
    "type": "vimeo",
    "id": "1181231416"
  },
  "OLYMPIC RINGS PASTA": {
    "type": "youtube",
    "id": "xqHLGlAFG6M"
  },
  "OM BDR": {
    "type": "youtube",
    "id": "WaS2AMZ_ef8"
  },
  "ONE MORE QUESTION": {
    "type": "youtube",
    "id": "SCS8CJGqSDo"
  },
  "OREO COWS": {
    "type": "youtube",
    "id": "F2EjJgR0adE"
  },
  "OREO COWS FILM": {
    "type": "vimeo",
    "id": "1204016718"
  },
  "ORIGINAL FOREVER": {
    "type": "vimeo",
    "id": "1096025616"
  },
  "OWN YOUR FLOW": {
    "type": "vimeo",
    "id": "1164169063"
  },
  "OWNERS REUNIONS": {
    "type": "vimeo",
    "id": "1187065311"
  },
  "PAID SICK LEAVE FOR COWS": {
    "type": "youtube",
    "id": "vQ6A_4_V5j8"
  },
  "PEDIGREE CARAMELO": {
    "type": "youtube",
    "id": "prMM0H9psRs"
  },
  "PLAYED BY HUMANS": {
    "type": "youtube",
    "id": "1lZ696Kd6ic"
  },
  "POPE YES": {
    "type": "vimeo",
    "id": "1189119597"
  },
  "PRESERVED PROMOS": {
    "type": "youtube",
    "id": "U_sdlCijjr4"
  },
  "PRICE PACKS": {
    "type": "youtube",
    "id": "wXx6z3mDnVc"
  },
  "PRIME TIME 0.7": {
    "type": "vimeo",
    "id": "1188326564"
  },
  "PROJECT GENIE": {
    "type": "youtube",
    "id": "D448m_QWf74"
  },
  "PROTECT THE PEANUT": {
    "type": "vimeo",
    "id": "1190628293"
  },
  "PROTEST MARCH OF THE PENGUINS": {
    "type": "vimeo",
    "id": "1134895971"
  },
  "PULL UP": {
    "type": "youtube",
    "id": "IqC3YrIzbQw"
  },
  "R2R\u2190": {
    "type": "youtube",
    "id": "ayOgEZRVhkg"
  },
  "RACING, CLUB, VAMOS": {
    "type": "youtube",
    "id": "JUHVh0ZBVWI"
  },
  "RADIO TIME MACHINE": {
    "type": "youtube",
    "id": "2LLsJbmUM_A"
  },
  "RE-COMMERCE ATACAMA": {
    "type": "youtube",
    "id": "7Fl7kBNB78I"
  },
  "RECIPE FOR CHANGE": {
    "type": "youtube",
    "id": "dMn7KGnIAYg"
  },
  "RELAX YOUR TIGHT END": {
    "type": "youtube",
    "id": "CV7KcrlJwk8"
  },
  "RENU VS THE CITY": {
    "type": "youtube",
    "id": "HLU-haLXXDQ"
  },
  "RESIZE THE PRICE": {
    "type": "vimeo",
    "id": "1203767931"
  },
  "REVERSE MEDIA SCHEDULE": {
    "type": "youtube",
    "id": "zUr0Jjlm5WM"
  },
  "ROAD TEST ROYALE": {
    "type": "youtube",
    "id": "R-M9yiTRTn8"
  },
  "ROOFTOP REVIVAL": {
    "type": "youtube",
    "id": "4l6OtWlqBX0"
  },
  "ROSAL\u00cdA FT. BJ\u00d6RK, YVES TUMOR": {
    "type": "youtube",
    "id": "htQBS2Ikz6c"
  },
  "RUN BACK THE MIRACLE": {
    "type": "youtube",
    "id": "twUi2ykMybw"
  },
  "SANTA MARIA PUEBLO HOTEL": {
    "type": "youtube",
    "id": "0qMWo7jbXdo"
  },
  "SAVINGS INDEX": {
    "type": "youtube",
    "id": "yWbSxerwwIc"
  },
  "SCRATCH YOUR DATA": {
    "type": "vimeo",
    "id": "1186417316"
  },
  "SEARCHING FOR BIRDS ON WIRES": {
    "type": "vimeo",
    "id": "1202133381"
  },
  "SERVING SINGLES": {
    "type": "youtube",
    "id": "Pt6ksxmQ4qo"
  },
  "SHAPE OF DREAMS": {
    "type": "vimeo",
    "id": "1191960468"
  },
  "SHEEP HAPPENS": {
    "type": "vimeo",
    "id": "1195091152"
  },
  "SHOT WITHOUT PERMISSION": {
    "type": "youtube",
    "id": "l88beT9gxCk"
  },
  "SHOWROOM ON ICE": {
    "type": "vimeo",
    "id": "1166962676"
  },
  "SILENT CLEANING": {
    "type": "youtube",
    "id": "k8mdhE0NLjg"
  },
  "SILENT EDITION": {
    "type": "vimeo",
    "id": "1185650047"
  },
  "SLEEP TALK REVIEWS": {
    "type": "youtube",
    "id": "BNAfX0lKSjg"
  },
  "SOCIALIZING BILLBOARDS": {
    "type": "vimeo",
    "id": "1187150318"
  },
  "SOIL STAY": {
    "type": "vimeo",
    "id": "1152091660"
  },
  "SOS POS": {
    "type": "youtube",
    "id": "GVdCoJEhO6M"
  },
  "SPOTS FOR SHOPS": {
    "type": "vimeo",
    "id": "1188408425"
  },
  "STELLA LOCAD GUIDES": {
    "type": "youtube",
    "id": "eTSgT22ZGb4"
  },
  "STEPH CURRY SHOOTS THE MOON": {
    "type": "youtube",
    "id": "7sPk_BgjNZs"
  },
  "STRANGER THINGS IN SEARCH": {
    "type": "youtube",
    "id": "FDnNW_HPEwg"
  },
  "SUNBURNT CAR": {
    "type": "vimeo",
    "id": "1203492324"
  },
  "SUPERNOVA ADAPTIVE": {
    "type": "vimeo",
    "id": "1203657943"
  },
  "T-REX LEATHER": {
    "type": "youtube",
    "id": "I2sHOyoL0J4"
  },
  "TD FRACTIONAL WINDOW SHOPPING": {
    "type": "youtube",
    "id": "zfwb3VSq5k4"
  },
  "TERMS AND CONDITIONS OF BEING A GIRL": {
    "type": "youtube",
    "id": "XcYYt-gVd_k"
  },
  "THE 58 YEAR OLD ROOKIE": {
    "type": "youtube",
    "id": "QMmkWujIIqs"
  },
  "THE AREPA THAT UNITES": {
    "type": "vimeo",
    "id": "1178488229"
  },
  "THE BIG REDEMPTION": {
    "type": "vimeo",
    "id": "1164767168"
  },
  "THE BIRDWATCHER": {
    "type": "youtube",
    "id": "DbL7yAqIQaw"
  },
  "THE CATRACE": {
    "type": "youtube",
    "id": "jCp9ruDK2c0"
  },
  "THE CHOICE": {
    "type": "vimeo",
    "id": "1182423422"
  },
  "THE CLUB IS YOURS": {
    "type": "vimeo",
    "id": "1126924315"
  },
  "THE COOLEST IHRAM": {
    "type": "youtube",
    "id": "nM9gGTCLpr8"
  },
  "THE DR PEPPER JINGLE": {
    "type": "youtube",
    "id": "wAL5peTQD8M"
  },
  "THE FANDOM COMEBACK": {
    "type": "youtube",
    "id": "rpNmqb7caHw"
  },
  "THE FAROE ISLANDS SPACE PROGRAM": {
    "type": "youtube",
    "id": "I182TbpuV0U"
  },
  "THE FEATHERED LAMB": {
    "type": "youtube",
    "id": "z3DKt55_nKw"
  },
  "THE FILET-O-FISH FACEBOOK SOCIETY OF 2012": {
    "type": "youtube",
    "id": "Qd2k250KMvo"
  },
  "THE FINAL COPY OF ILON SPECHT": {
    "type": "vimeo",
    "id": "1094956645"
  },
  "THE GOLDEN ZONE": {
    "type": "youtube",
    "id": "joqkwPzQ8VQ"
  },
  "THE GRIT & THE GLITTER": {
    "type": "youtube",
    "id": "w0PXDwXygLE"
  },
  "THE GUCCI LIDO CAMPAIGN": {
    "type": "vimeo",
    "id": "1094701053"
  },
  "THE HEALING STAGE": {
    "type": "youtube",
    "id": "emJD7ROfBKE"
  },
  "THE KAPRAO CRIMINALS": {
    "type": "youtube",
    "id": "CIN0cXeX2Kk"
  },
  "THE KIDNEY PASS": {
    "type": "youtube",
    "id": "YAcnwoPbKmk"
  },
  "THE KITKAT HEIST": {
    "type": "vimeo",
    "id": "1204147459"
  },
  "THE LEAST MOST INTERESTING MAN": {
    "type": "youtube",
    "id": "X2VLDiIwKpk"
  },
  "THE LEGACY OF VIRGINIA GIUFFRE": {
    "type": "youtube",
    "id": "J_45sFUTkhw"
  },
  "THE LIFE-SAVING RECEIPT": {
    "type": "youtube",
    "id": "FB9AoYWpm6E"
  },
  "THE MAGAZINE IN ALL FORMATS": {
    "type": "youtube",
    "id": "VCq3MyrBack"
  },
  "THE MEXICAN DREAM": {
    "type": "vimeo",
    "id": "1197514785"
  },
  "THE MISSING MANAGERS": {
    "type": "youtube",
    "id": "Z7zomJ1eVSw"
  },
  "THE MISSING WORD DICTIONARY": {
    "type": "youtube",
    "id": "OQdjpHoyQVs"
  },
  "THE MOST EPIC WATCH PARTY GROUP": {
    "type": "vimeo",
    "id": "1192014627"
  },
  "THE M\u0100ORI ROLL CALL": {
    "type": "youtube",
    "id": "cQE_cxhHlqc"
  },
  "THE PAID RELIEF, NA CONTA DA DOR": {
    "type": "youtube",
    "id": "okEfc6JUymw"
  },
  "THE PASSWORD HEIST": {
    "type": "youtube",
    "id": "6zm0ARkEpKM"
  },
  "THE PERIOD UNIFORM": {
    "type": "youtube",
    "id": "J_lOZXpp9TI"
  },
  "THE PHILIPSTOWN WIRECAR GRAND PRIX": {
    "type": "vimeo",
    "id": "1184143191"
  },
  "THE PUB THAT REFUSED TO DIE": {
    "type": "vimeo",
    "id": "1190924385"
  },
  "THE RELATIONSHIP AID": {
    "type": "youtube",
    "id": "7MXNZv1fT8w"
  },
  "THE RING: THE LEGACY CONTINUES": {
    "type": "vimeo",
    "id": "1159152038"
  },
  "THE SAFE PACK": {
    "type": "youtube",
    "id": "rs5cLYmaL2E"
  },
  "THE SHAKESPEARE BIC": {
    "type": "vimeo",
    "id": "1153593001"
  },
  "THE SHOOTING": {
    "type": "youtube",
    "id": "-HG82GaTY3I"
  },
  "THE SWEDISH PRESCRIPTION": {
    "type": "vimeo",
    "id": "1157558881"
  },
  "THE SWITCH HIT BY MIKKELLER": {
    "type": "vimeo",
    "id": "1203778752"
  },
  "THE THOUSAND SPONSORS OF MUNI": {
    "type": "youtube",
    "id": "tq775MZGE48"
  },
  "THE TIGER": {
    "type": "youtube",
    "id": "Y7MgcDKBPpw"
  },
  "THE TREASURE HUNT": {
    "type": "youtube",
    "id": "dJPTCeSvDuo"
  },
  "THE TRIANGLE THEORY": {
    "type": "vimeo",
    "id": "1195946969"
  },
  "THE TROJAN FAX": {
    "type": "vimeo",
    "id": "1203429857"
  },
  "THE UNBURIED CASKET": {
    "type": "youtube",
    "id": "_5C2dHOJrbQ"
  },
  "THE UNDROPPED KIT": {
    "type": "youtube",
    "id": "gyzNtC_3Fnw"
  },
  "THE UNOFFICIAL OFFICIAL SOUND OF F1": {
    "type": "youtube",
    "id": "MteFVMaD-0M"
  },
  "THE VOLVO CARS SAFETY STANDARD": {
    "type": "youtube",
    "id": "jL3XxEk0HX0"
  },
  "THE WEDDING RICE": {
    "type": "youtube",
    "id": "Xop6AbopFeQ"
  },
  "THE WIZARD OF OZ AT SPHERE": {
    "type": "youtube",
    "id": "9d8HMYn-upo"
  },
  "THE YANGZHOU QIAO BEI MUSICAL SUITE": {
    "type": "youtube",
    "id": "2mH41-1bJVA"
  },
  "THREE WORDS": {
    "type": "youtube",
    "id": "pY-03zuV7mE"
  },
  "TIFFANY \u00d7 NETFLIX\u2019S FRANKENSTEIN": {
    "type": "youtube",
    "id": "8nI6O-P5BuM"
  },
  "TIKTOK CURRENCY": {
    "type": "youtube",
    "id": "ixCFzDFLu_8"
  },
  "TILT ACCESSIBLE BEAUTY": {
    "type": "youtube",
    "id": "sugJkmlq9To"
  },
  "TINY COFFEE SHOPS": {
    "type": "vimeo",
    "id": "1196607563"
  },
  "TWO-WAY DEAL": {
    "type": "vimeo",
    "id": "1168852605"
  },
  "U UP?": {
    "type": "youtube",
    "id": "tJ4yKUxPxKE"
  },
  "UBERL\u00c2NDIA E.C.": {
    "type": "vimeo",
    "id": "1186558075"
  },
  "UKRAINE AIR RAID ALERTS": {
    "type": "youtube",
    "id": "WOWTIZLMosw"
  },
  "UNCOVERING RACISM": {
    "type": "youtube",
    "id": "aVAw0goCyE0"
  },
  "UNFADING LOVE": {
    "type": "vimeo",
    "id": "1150774030"
  },
  "UNTAUGHT HISTORY EDITION": {
    "type": "youtube",
    "id": "qqy_jmxyn4Q"
  },
  "UNWATCHED GOALS": {
    "type": "vimeo",
    "id": "1191276115"
  },
  "UTRECHT ENERGIZED": {
    "type": "youtube",
    "id": "osZnUXoyVfQ"
  },
  "UV TATTOO TO LEARN": {
    "type": "youtube",
    "id": "kNZ9PQn-Ewk"
  },
  "UVA UVA BOMB\u00d3N": {
    "type": "vimeo",
    "id": "1204190443"
  },
  "VASELINE AND THE REAL NIGERIAN PRINCE": {
    "type": "youtube",
    "id": "eNYA89Z97Gs"
  },
  "VASELINE ORIGINALS": {
    "type": "youtube",
    "id": "hzq9lR5SsNo"
  },
  "VASELINE VERIFIED": {
    "type": "vimeo",
    "id": "1082798104"
  },
  "VEHICLE OF HOPE": {
    "type": "youtube",
    "id": "YfQbzgQfOKI"
  },
  "VIAGRA BLUE BRANDS": {
    "type": "vimeo",
    "id": "1203387960"
  },
  "VISION CONSTANTLY PULSED: SIGHT BEYOND SEEING": {
    "type": "vimeo",
    "id": "1203792583"
  },
  "VISION PULSE: SIGHT BEYOND SEEING": {
    "type": "vimeo",
    "id": "1203792583"
  },
  "VOICE OF FOOD": {
    "type": "youtube",
    "id": "sPCiIZnvyGg"
  },
  "WARMER TOGETHER": {
    "type": "youtube",
    "id": "nelgWVfxDHk"
  },
  "WELCOME BACK, PAISANO": {
    "type": "youtube",
    "id": "sFLMnLf2HeI"
  },
  "WHO\u2019S WAITING FOR YOU?": {
    "type": "youtube",
    "id": "OvwrHl__VKY"
  },
  "WHO\u2019S WAITING FOR YOU? FILM": {
    "type": "vimeo",
    "id": "1158967087"
  },
  "WIFI INVASION": {
    "type": "vimeo",
    "id": "1198392889"
  },
  "YOUR WAY OUT": {
    "type": "youtube",
    "id": "HQJMzTpckPo"
  },
  "YOU\u2019VE BEEN WARNED": {
    "type": "vimeo",
    "id": "1148477437"
  },
  "ZIP CODE EXAM": {
    "type": "youtube",
    "id": "iSAmHA_hjuw"
  },
  "\u00a1HOLA!": {
    "type": "youtube",
    "id": "RZ_RvWpxEhw"
  },
  "\u201cBASED ON A TRUE STORY\u201d": {
    "type": "vimeo",
    "id": "1199684705"
  },
  "A MINECRAFT MOVIE MEAL": {
    "type": "external",
    "url": "https://www.wk.com/work/mcdonalds-minecraft/?utm_source=chatgpt.com"
  },
  "AFFORDABLE MASTERPIECES": {
    "type": "external",
    "url": "https://www.ogilvy.com/work/affordable-masterpieces"
  },
  "AMAZ\u00d4NIA ALIVE": {
    "type": "external",
    "url": "https://www.latinspots.com/pieza/comercial/amaznia-alive-book/51333"
  },
  "ANIMAL ATTRACTION": {
    "type": "external",
    "url": "https://lbbonline.com/work/172180"
  },
  "ART\u2019S MISSING PERIOD": {
    "type": "external",
    "url": "https://www.ogilvy.com/work/arts-missing-period"
  },
  "BAD BUNNY HALFTIME SHOW CAMPAIGN": {
    "type": "external",
    "url": "https://www.dandad.org/work/d-ad-awards-archive/bad-bunny-halftime-show-campaign"
  },
  "BLIZZARD AS USUAL": {
    "type": "external",
    "url": "https://lbbonline.com/news/Tim-Hortons-Blizzard-GUT-Toronto-Always-Yours-OOH"
  },
  "BULLET MACHINE": {
    "type": "external",
    "url": "https://www.ogilvy.com/work/bullet-machine"
  },
  "DIRT IS GLORY": {
    "type": "external",
    "url": "https://www.dandad.org/work/d-ad-awards-archive/dirt-is-glory"
  },
  "DRAWN TO D&AD": {
    "type": "external",
    "url": "https://www.oneclub.org/awards/theoneshow/-award/63912/drawn-to-dad/"
  },
  "DRESSED FOR WIMBLEDON": {
    "type": "external",
    "url": "https://www.dandad.org/work/d-ad-awards-archive/dressed-for-wimbledon"
  },
  "EVERYBODY COINBASE": {
    "type": "external",
    "url": "https://www.dandad.org/work/d-ad-awards-archive/everybody-coinbase"
  },
  "FOR YOUR RIGHT TO BE CURIOUS": {
    "type": "external",
    "url": "https://www.dandad.org/work/d-ad-awards-archive/npr-for-your-right-to-be-curious"
  },
  "GAMING FLUTE": {
    "type": "external",
    "url": "https://www.katiebero.com/work-1/skittles-gaming-flute"
  },
  "ICONIC HOME": {
    "type": "external",
    "url": "https://www.oneclub.org/awards/theoneshow/-award/63863/iconic-home/"
  },
  "IKEA BRIGHTON STORE LAUNCH": {
    "type": "external",
    "url": "https://www.dandad.org/work/d-ad-awards-archive/ikea-brighton-store-launch"
  },
  "JELL-O-METER": {
    "type": "external",
    "url": "https://www.ryanmorejon.com/jellometer-1"
  },
  "JUAN GABRIEL": {
    "type": "external",
    "url": "https://www.monks.com/case-studies/netflix-juan-gabriel-ballad-of-alberto-live-experience"
  },
  "LAWS UNDER ATTACK": {
    "type": "external",
    "url": "https://www.dandad.org/work/d-ad-awards-archive/not-a-target"
  },
  "POCKET-SIZED HALFTIME SHOW": {
    "type": "external",
    "url": "https://www.latinspots.com/pieza/comercial/pocket-sized-halftime-show/51349"
  },
  "RAIL CLOCK": {
    "type": "external",
    "url": "https://www.designbridge.com/news/rail-clock-new-face-of-time"
  },
  "SAWAAL UTHAO": {
    "type": "external",
    "url": "https://winners.kyoorius.com/winners/2026/kma/12195-sawaal-uthao"
  },
  "SEE A SEIZURE": {
    "type": "external",
    "url": "https://1drv.ms/i/c/4e9ba448a9f90a4d/IQAA56c7JvTyTb9SAfl2KrNQAVpRbTq6nx_Vle9gZjwTgIc?e=YGOQrf"
  },
  "SIMPLY NKD\u2122 THE RENAISSANCE OF SNACKING": {
    "type": "external",
    "url": "https://alecplourde.com/The-Renaissance-of-Snacking-NKD"
  },
  "THE BITE": {
    "type": "external",
    "url": "https://www.naomifrankel.com/work/cutwater-x38np-kpl8f-jabg2-3wzaj-447cb-k88ef-mb98b-tz2ng-7x45l-jf7wx-mxs7e"
  },
  "THE GREY SWAN": {
    "type": "external",
    "url": "https://sollin.xyz/THE-GREY-SWAN"
  },
  "THE LAST COKE IN THE DESERT": {
    "type": "external",
    "url": "https://gracereinhold.com/the-last-coke-in-the-desert"
  },
  "THE NEW FACE OF LEGS": {
    "type": "external",
    "url": "https://rickybowry.com/portfolio/cerave-new-face-of-legs/"
  },
  "THE PERIODIC FABLE": {
    "type": "external",
    "url": "https://www.oneclub.org/awards/theoneshow/-award/64427/the-periodic-fable/"
  },
  "WHEREVER LIFE GOES": {
    "type": "external",
    "url": "https://www.oneclub.org/awards/theoneshow/-award/64800/wherever-life-goes/"
  },
  "AMAZONIA": {
    "type": "youtube",
    "id": "2KxSdW6k4LY"
  },
  "COLORFOOD": {
    "type": "youtube",
    "id": "dlonvMFZ3MA"
  },
  "COLUMBIA": {
    "type": "youtube",
    "id": "GeR2pRweJEM"
  },
  "DEPARTURES": {
    "type": "youtube",
    "id": "UpRuemIT9Is"
  },
  "DISH": {
    "type": "vimeo",
    "id": "1135476314"
  },
  "DUOBELL": {
    "type": "vimeo",
    "id": "1189880268"
  },
  "FASCINATING": {
    "type": "youtube",
    "id": "ZIUHE3BA5Kw"
  },
  "FIRECATCHERS": {
    "type": "youtube",
    "id": "YFSRJpoZHoU"
  },
  "HAVEN": {
    "type": "youtube",
    "id": "Pwf50R9flkU"
  },
  "HEARAPY": {
    "type": "vimeo",
    "id": "1188973826"
  },
  "HELICOPTER": {
    "type": "vimeo",
    "id": "1154051428"
  },
  "ICEDENTITY": {
    "type": "youtube",
    "id": "3ZHZSK7cOv0"
  },
  "LUTHER": {
    "type": "vimeo",
    "id": "1079902757"
  },
  "MAFIA": {
    "type": "vimeo",
    "id": "1182109710"
  },
  "SAMURAI": {
    "type": "vimeo",
    "id": "1182110177"
  },
  "SCORECOUPONS": {
    "type": "vimeo",
    "id": "1203937466"
  },
  "SLIDE": {
    "type": "vimeo",
    "id": "1168177137"
  },
  "SUFFERING": {
    "type": "youtube",
    "id": "0RRsw4UbZ-E"
  },
  "TABLEAU": {
    "type": "youtube",
    "id": "WwhKpyiGjys"
  },
  "TOCAYOS": {
    "type": "youtube",
    "id": "r5M5spNm-fI"
  },
  "TRIP": {
    "type": "vimeo",
    "id": "1122948088"
  },
  "UNAVAILABLE": {
    "type": "vimeo",
    "id": "1162681848"
  },
  "UNLOVED": {
    "type": "vimeo",
    "id": "1149404148"
  },
  "WESTERN": {
    "type": "vimeo",
    "id": "1182110488"
  },
  "REFLECTIONS": {
    "type": "external",
    "url": "https://www.oneclub.org/awards/theoneshow/-award/63857/reflections/"
  }
}
